export const twoCharsRegex = new RegExp(/.*\S.*\S.*/);